var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',_vm._g(_vm._b({attrs:{"type":"primary"},on:{"click":function($event){return _vm.$scrollTo('register-section')}}},'vs-button',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n  "+_vm._s(_vm.$t('startNow'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }